import { ActiveBenificaryAccount, ActiveDepositType, ActiveModeOfPayment, ManagerListForPayments } from './ActiveClasses';

export class PaymentOpenerUser {
  paymentId: number = 0;
  openerUser: number = 0;
}

export class PaymentDocDetailsProperties {

  id: number = 0;
  
  attachmentName: string = "";
  
  attachmentFilePath: string = "";
  
  creationUser: number = 0;
  
  paymentId: number = 0;
  status: string = "";
  fileextension: string = "";

}

export class PaymentBaseData {
  depositTypes: ActiveDepositType[] = [];
  //{ get; set; }
  modeOfPayments: ActiveModeOfPayment[] = [];
  accounts: ActiveBenificaryAccount[] = [];
  managerList: ManagerListForPayments[] = [];

  //{ get; set; }

}
export class FileDownloadType {
  fullPath: string;
  fileExtension: string;
}
export class PaymentRightsProperties {
  //paymentProcess: boolean = false;
  addPayment: boolean = false;
  deletePayment: boolean = false;
  approvePayment: boolean = false;
}


export class PaymentProperties {
  paymentId: number = 0;
  backSystemPaymentId: number = 0;
  modeOfPaymentId: number = 0;
  openerUser: number = 0;
  approvingAgencyId: string = "";
  agencyId: string = "";
  branchId: string = "";
  amount: number = 0;
  accountNo: string = "";
  depositTypeId: number = 0;
  paymentDate: Date;

  documentReference: string = "";

  creationUser: number = 0;
  modifyUser: number = 0;
  approval_RejectionUser: number = 0;
  approval_RejectionDateTime: Date;
  approval_RejectionUserName: string = "";
  modifyDateTime: Date;
  creationDateTime: Date;
  reasonForRejection: string = "";
  status: string = "";
  isApproved: boolean = false;
  url: string = "";
  inProcess: boolean;
  docList: PaymentDocDetailsProperties[] = [];
  backSystemCompanyId: number = 0;
  ipgTransactionId: string = "";
  creationUserBackCompanyId: number = 0;
  creationUserBackCustomer: string = "";
  backSystemBranchName: string = "";
  backSystemBranchLocationId: number = 0;
  glAccountNumber: string = "";
  glAccountName: string = "";
  backSytemBranchLocation: string = "";
  requesterImmediateParent: string = "";

}
//end

export class PaymentList {
  paymentId: number = 0;
  paymentDate: string = "";
  amount: number = 0;
  depositType: string = "";
  account: string = "";
  agencyName: string = "";
  //27-March-24
  status: string = "";
  paymentType: string = "";
  requestDateTime: Date;
  referenceNumber: string = "";
  //end
  // status: boolean = false;

}

//27-March-24 New
export class NewPaymentRequest {
  paymentModeTypeId: number = 0;
  paymentTypeId: number = 0;
  newPaymentRequest: boolean = false;
  paymentOpenFrom: string;
}
export class PaymentSearch {
  modeOfPayment: number;
  requestDateFrom: Date;
  requestDateTo: Date;
  depositType: number;
  paymentStatus: string;
  managerId: number;
  agencyId: string;
  userId: number;
}
export class PaymentResponseMessage {
  status: boolean;
  message: string;
  responseData: any;
}
//Related To Magnati
export class GatewayURLSCProps {
  url: string;
  key: string = "";
  merchantID: string = "";
  srvSuc: string = "";
  srvFlr: string = "";
}
